import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['4 tomos técnicos premium', '4 bonos estratégicos', 'Acceso inmediato', 'Pago seguro', 'Garantía 7 días'];
  const maestroFeatures = ['Todo lo del MegaPack (4 tomos + 4 bonos)', '500 preguntas tipo examen EASA Part-66', '500 preguntas tipo examen FAA AMT', 'Simulacros cronometrados con hojas de respuestas', 'Plan de estudio de 75 días integrado'];
  const comparisonRows = [{
    sit: 'Exámenes EASA Part-66',
    sin: 'Buscás preguntas sueltas en foros',
    con: 'Banco de 500 preguntas oficiales'
  }, {
    sit: 'Exámenes FAA AMT',
    sin: 'No tenés material de práctica',
    con: 'Banco de 500 preguntas actualizadas'
  }, {
    sit: 'Práctica de examen',
    sin: 'Evaluaciones sin límite de tiempo',
    con: 'Simulacros cronometrados reales'
  }, {
    sit: 'Organización del estudio',
    sin: 'Tus alumnos no saben por dónde empezar',
    con: 'Plan de estudio de 75 días integrado'
  }];
  return <section id="pricing" className="py-24 bg-slate-900" data-id="element-195">
      <div className="container mx-auto px-4" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-198">
            💳 ELEGÍ TU PACK
          </h2>
          <p className="text-slate-300 text-[16px]" data-id="element-199">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-200">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 rounded-3xl p-8 shadow-2xl border border-slate-800 flex flex-col h-full relative z-10" data-id="element-201">
            <div className="mb-6" data-id="element-202">
              <p className="text-slate-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-203">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-204">
                🏆 MegaPack Técnico en Aeronáutica 360
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-205">
                Los 4 tomos técnicos premium + 4 bonos estratégicos listos para
                el aula.
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800" data-id="element-206"></div>

            <div className="mb-8" data-id="element-207">
              <div className="flex items-end gap-2" data-id="element-208">
                <span className="text-5xl font-black text-white" data-id="element-209">$19.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-210">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-211">$45.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-212">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
                  <Check className="w-5 h-5 text-slate-500 shrink-0 mt-0.5" data-id="element-214" />
                  <span className="text-slate-300" data-id="element-215">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53719987323198:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-216">
              <Button variant="outline" size="lg" fullWidth data-id="element-217">
                🟡 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-950 rounded-3xl p-8 shadow-2xl border-2 border-slate-300 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-218">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-219">
              <Star className="w-4 h-4 fill-slate-950" data-id="element-220" /> MÁS ELEGIDO · MEJOR
              VALOR
            </div>

            <div className="mb-6 mt-2" data-id="element-221">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-222">
                ⭐ MegaPack 360 + Pack Maestro Avanzado
              </h3>
              <p className="text-slate-300 font-bold" data-id="element-223">
                Llevás el pack completo más el material para preparar a tus
                alumnos para las certificaciones aeronáuticas reales.
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-blue-900/50" data-id="element-224"></div>

            <div className="mb-8" data-id="element-225">
              <div className="flex items-end gap-2" data-id="element-226">
                <span className="text-5xl font-black text-white" data-id="element-227">$27.990</span>
                <span className="text-xl font-bold text-slate-300 mb-1" data-id="element-228">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-229">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-230">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-231">
                  <Check className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-232" />
                  <span className={i === 0 ? 'text-slate-200 font-bold' : 'text-slate-300'} data-id="element-233">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53719999643966:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-234">
              <Button variant="primary" size="lg" fullWidth data-id="element-235">
                🟡 LLEVAR PACK MAESTRO AVANZADO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-slate-400 text-sm mb-20" data-id="element-236">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Pack Maestro Details */}
        <div className="max-w-4xl mx-auto" data-id="element-237">
          <div className="text-center mb-10" data-id="element-238">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-239">
              <Target className="w-8 h-8 text-slate-300" data-id="element-240" />
              ¿QUÉ AGREGA EL PACK MAESTRO AVANZADO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-241">
            <div className="min-w-[700px]" data-id="element-242">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-243">
                <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-244">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-245">
                  ❌ Sin PACK MAESTRO
                </div>
                <div className="font-bold text-slate-300 uppercase text-sm tracking-wider" data-id="element-246">
                  ✅ Con PACK MAESTRO
                </div>
              </div>

              <div className="space-y-2" data-id="element-247">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-slate-950/60 rounded-xl p-4 items-center border border-slate-800" data-id="element-248">
                    <div className="text-slate-300 font-medium text-sm" data-id="element-249">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-250">{row.sin}</div>
                    <div className="text-slate-200 font-medium text-sm" data-id="element-251">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-slate-800/50 rounded-2xl p-6 md:p-8 border border-slate-700" data-id="element-252">
            <h4 className="font-bold text-slate-200 mb-6 uppercase tracking-wider" data-id="element-253">
              EL PACK MAESTRO AVANZADO INCLUYE:
            </h4>
            <div className="space-y-6" data-id="element-254">
              <div data-id="element-255">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-256">
                  <span className="text-slate-300" data-id="element-257">🇪🇺</span> BANCO DE 500
                  PREGUNTAS EASA PART-66
                </p>
                <p className="text-slate-300 text-sm" data-id="element-258">
                  Material de práctica real para la certificación europea. Ideal
                  para elevar el nivel de exigencia de tus alumnos y prepararlos
                  para estándares internacionales.
                </p>
              </div>
              <div data-id="element-259">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-260">
                  <span className="text-slate-300" data-id="element-261">🇺🇸</span> BANCO DE 500
                  PREGUNTAS FAA AMT
                </p>
                <p className="text-slate-300 text-sm" data-id="element-262">
                  Preguntas oficiales de la Federal Aviation Administration
                  (Airframe & Powerplant). El complemento perfecto para evaluar
                  conocimientos técnicos profundos.
                </p>
              </div>
              <div data-id="element-263">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-264">
                  <span className="text-slate-300" data-id="element-265">⏱️</span> SIMULACROS
                  CRONOMETRADOS
                </p>
                <p className="text-slate-300 text-sm" data-id="element-266">
                  Exámenes de práctica con límite de tiempo y hojas de
                  respuestas listas para imprimir. Acostumbrá a tus alumnos a la
                  presión de un examen de certificación real.
                </p>
              </div>
              <div data-id="element-267">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-268">
                  <span className="text-slate-300" data-id="element-269">📅</span> PLAN DE ESTUDIO DE
                  75 DÍAS
                </p>
                <p className="text-slate-300 text-sm" data-id="element-270">
                  Una guía estructurada paso a paso para integrar todo el
                  material del MegaPack y el Pack Maestro en un cronograma de
                  estudio efectivo para tus alumnos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}